// Customer Portal shell. External customers (role='customer') get this
// instead of the internal Sidebar+Masthead chrome -- a single navy top
// bar with three nav links and a sign-out. Deliberately minimal: the
// portal should feel like a clean status page, not a CRM.

import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext.jsx';

export default function PortalShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/portal/overview')
      .then((res) => { if (!cancelled) setOverview(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  function handleSignOut() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="portal-app">
      <header className="portal-header">
        <div className="portal-brand">
          <div className="portal-logo" aria-hidden="true">X</div>
          <div className="portal-wordmark">
            <span className="portal-wordmark-main">XSite Group</span>
            <span className="portal-wordmark-sub">Customer Portal</span>
          </div>
        </div>
        <nav className="portal-nav">
          <NavLink to="/portal" end>Sites</NavLink>
          <NavLink to="/portal/health">Health</NavLink>
          <NavLink to="/portal/map">Map</NavLink>
          <NavLink to="/portal/onboarding">Onboarding</NavLink>
          <NavLink to="/portal/renewals">Renewals</NavLink>
          <NavLink to="/portal/support">Support</NavLink>
          <NavLink to="/portal/users">Users</NavLink>
        </nav>
        <div className="portal-user">
          {overview?.company && <span className="portal-company">{overview.company}</span>}
          <span className="portal-user-name">{user?.name || user?.email}</span>
          <button type="button" className="portal-signout" onClick={handleSignOut}>Sign out</button>
        </div>
      </header>
      <main className="portal-main">{children}</main>
    </div>
  );
}
